import styled, { createGlobalStyle } from 'styled-components';
import { Modal } from 'antd';

/** Full-screen shell; mask/wrapper sit outside Modal content. */
export const OnboardingIntentModalGlobalStyle = createGlobalStyle`
  .onboarding-intent-modal-wrap {
    .ant-modal-mask {
      background: #0b0f1b;
    }

    .ant-modal {
      top: 0 !important;
      padding-bottom: 0;
      max-width: 100vw;
      margin: 0;
      width: 100vw !important;
      height: 100vh;
    }

    .ant-modal-content {
      height: 100vh;
      border-radius: 0;
      box-shadow: none;
    }

    .ant-modal-body {
      height: 100%;
      padding: 0;
    }
  }
`;

export const OnboardingIntentModalStyle = styled(Modal)`
  &.ant-modal {
    max-width: 100vw;
    width: 100vw !important;
    padding-bottom: 0;
    top: 0;
  }

  .ant-modal-content {
    background: #111823;
    border-radius: 0;
    padding: 0;
    overflow: hidden;
    height: 100vh;
    box-shadow: none;
  }

  .ant-modal-body {
    padding: 0;
    height: 100%;
  }

  .intent-shell {
    display: grid;
    /* Brand accent strip on the left; form gets the majority of focus area */
    grid-template-columns: clamp(200px, 28vw, 360px) minmax(0, 1fr);
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background: #111823;
  }

  .intent-left {
    position: relative;
    overflow: hidden;
    background:
      radial-gradient(circle at 20% 18%, rgba(255, 255, 255, 0.22) 0%, transparent 40%),
      radial-gradient(circle at 78% 72%, rgba(0, 122, 255, 0.55) 0%, transparent 48%),
      radial-gradient(circle at 40% 90%, rgba(0, 89, 209, 0.45) 0%, transparent 42%),
      linear-gradient(155deg, #4da3ff 0%, #007aff 32%, #0059d1 62%, #0b1f3a 100%);
  }

  .intent-left-glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(22px);
    pointer-events: none;
    will-change: transform, opacity;
  }

  .intent-left-glow--one {
    width: 200px;
    height: 200px;
    top: -40px;
    right: -50px;
    background: rgba(255, 255, 255, 0.28);
    animation: intentGlowFloatA 9s ease-in-out infinite;
  }

  .intent-left-glow--two {
    width: 220px;
    height: 220px;
    bottom: 10%;
    left: -60px;
    background: rgba(0, 122, 255, 0.45);
    animation: intentGlowFloatB 11s ease-in-out infinite;
  }

  .intent-left-glow--three {
    width: 140px;
    height: 140px;
    top: 42%;
    left: 28%;
    background: rgba(125, 211, 252, 0.28);
    animation: intentGlowFloatC 8s ease-in-out infinite;
  }

  @keyframes intentGlowFloatA {
    0%,
    100% {
      transform: translate3d(0, 0, 0) scale(1);
      opacity: 0.85;
    }
    50% {
      transform: translate3d(-12px, 18px, 0) scale(1.08);
      opacity: 1;
    }
  }

  @keyframes intentGlowFloatB {
    0%,
    100% {
      transform: translate3d(0, 0, 0) scale(1);
      opacity: 0.75;
    }
    50% {
      transform: translate3d(16px, -14px, 0) scale(1.12);
      opacity: 1;
    }
  }

  @keyframes intentGlowFloatC {
    0%,
    100% {
      transform: translate3d(0, 0, 0) scale(0.95);
      opacity: 0.55;
    }
    50% {
      transform: translate3d(10px, 12px, 0) scale(1.15);
      opacity: 0.9;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .intent-left-glow--one,
    .intent-left-glow--two,
    .intent-left-glow--three {
      animation: none;
    }
  }

  .intent-logo {
    position: absolute;
    left: 28px;
    bottom: 28px;
    height: 32px;
    width: auto;
    max-width: calc(100% - 48px);
    object-fit: contain;
    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.25));
  }

  .intent-right {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #111823;
    padding: 40px 48px;
    overflow-y: auto;
  }

  .intent-right-inner {
    width: 100%;
    max-width: 720px;
  }

  .intent-title {
    margin: 0 0 14px;
    font-size: 42px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #ffffff;
  }

  .intent-subtitle {
    margin: 0 0 36px;
    font-size: 18px;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.68);
  }

  .intent-options {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .intent-card {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
    text-align: left;
    background: #1a2332;
    border: 1.5px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    padding: 20px 22px;
    cursor: pointer;
    transition:
      border-color 0.15s ease,
      background 0.15s ease,
      box-shadow 0.15s ease;
    color: inherit;
  }

  .intent-card:hover:not(:disabled) {
    border-color: rgba(0, 122, 255, 0.55);
    background: #1e2a3d;
  }

  .intent-card.is-selected {
    border-color: #007aff;
    background: rgba(0, 122, 255, 0.12);
    box-shadow: 0 0 0 1px rgba(0, 122, 255, 0.35);
  }

  .intent-card:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .intent-card:focus-visible {
    outline: 2px solid #007aff;
    outline-offset: 2px;
  }

  .intent-card-icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.82);
    margin-top: 1px;

    .MuiSvgIcon-root {
      font-size: 26px;
    }
  }

  .intent-card.is-selected .intent-card-icon {
    background: rgba(0, 122, 255, 0.22);
    color: #63b3ed;
  }

  .intent-card-copy {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .intent-card-title {
    display: block;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    color: #ffffff;
  }

  .intent-card-desc {
    display: block;
    font-size: 16px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.62);
  }

  .intent-card-check {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    border-radius: 999px;
    border: 1.5px solid rgba(255, 255, 255, 0.22);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: transparent;
    font-size: 18px;
    margin-top: 10px;
    transition:
      background 0.15s ease,
      border-color 0.15s ease,
      color 0.15s ease;
  }

  .intent-card-check.is-visible {
    background: #007aff;
    border-color: #007aff;
    color: #ffffff;
  }

  .intent-error {
    margin: 16px 0 0;
    color: #fc8181;
    font-size: 15px;
    line-height: 1.4;
  }

  .intent-actions {
    margin-top: 28px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .intent-continue {
    width: 100%;
    border: none;
    border-radius: 14px;
    padding: 16px 22px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    background: #007aff;
    color: #ffffff;
    transition: background 0.15s ease, opacity 0.15s ease;
  }

  .intent-continue:hover:not(:disabled) {
    background: #0056cc;
  }

  .intent-continue:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .intent-logout {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 14px;
    padding: 14px 22px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    background: transparent;
    color: rgba(255, 255, 255, 0.82);
    transition: background 0.15s ease, border-color 0.15s ease;
  }

  .intent-logout:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.28);
  }

  .intent-logout:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .intent-footnote {
    margin: 20px 0 0;
    font-size: 14px;
    line-height: 1.45;
    text-align: center;
    color: rgba(255, 255, 255, 0.42);
  }

  @media (max-width: 800px) {
    .intent-shell {
      grid-template-columns: 1fr;
      min-height: 100vh;
    }

    .intent-left {
      min-height: 140px;
      max-height: 160px;
    }

    .intent-logo {
      left: 20px;
      bottom: 18px;
      height: 30px;
    }

    .intent-right {
      padding: 28px 20px 32px;
      align-items: flex-start;
    }

    .intent-right-inner {
      max-width: 100%;
    }

    .intent-title {
      font-size: 28px;
    }

    .intent-subtitle {
      margin-bottom: 24px;
      font-size: 15px;
    }

    .intent-card {
      padding: 16px;
      gap: 12px;
    }

    .intent-card-icon {
      width: 40px;
      height: 40px;

      .MuiSvgIcon-root {
        font-size: 22px;
      }
    }

    .intent-card-title {
      font-size: 16px;
    }

    .intent-card-desc {
      font-size: 14px;
    }

    .intent-continue {
      font-size: 16px;
      padding: 14px 18px;
    }

    .intent-logout {
      font-size: 15px;
      padding: 12px 18px;
    }
  }

  /* Slightly tighter scale on shorter viewports so nothing clips */
  @media (max-height: 780px) and (min-width: 801px) {
    .intent-title {
      font-size: 34px;
    }

    .intent-subtitle {
      margin-bottom: 24px;
      font-size: 16px;
    }

    .intent-card {
      padding: 16px 18px;
    }

    .intent-card-title {
      font-size: 18px;
    }

    .intent-card-desc {
      font-size: 15px;
    }

    .intent-options {
      gap: 12px;
    }

    .intent-actions {
      margin-top: 20px;
    }
  }
`;
